import React from 'react';

const BaseIcon = ({ SVGElement, color = 'currentColor', size = 24, children, ...props }) => {
  const className = 'mdi-icon ' + (props.className || '');
  return <SVGElement {...props} className={className} width={size} height={size} fill={color} />;
};

export default React.memo ? React.memo(BaseIcon) : BaseIcon;
